<div class="flex flex-col gap-6" *ngIf="vm$ | async as vm">
	<ng-container *ngFor="let missingField of vm.missingFields">
		<div
			class="flex justify-between self-center bg-orange-lightest w-full p-4 text-sm"
		>
			<div class="flex gap-4">
				<app-icon class="text-orange" [icon]="ICON.WARNING"></app-icon>
				{{ missingField.message }}
			</div>
			<span
				class="text-green w-fit cursor-pointer hover:underline ml-2"
				(click)="missingField.action()"
			>
				Add
			</span>
		</div>
	</ng-container>

	<div>
		<h5 class="h5 font-bold mb-4">General</h5>
		<div class="grid grid-cols-2 p-sm gap-x-6 gap-y-4">
			<ng-container
				[ngTemplateOutlet]="eregField"
				[ngTemplateOutletContext]="{
					field: {
						label: 'Priority',
						value: (vm.mortgage?.priority | ordinalSuffix),
						intercomAttr: 'charge-priority',
					},
				}"
			/>
			<ng-container
				[ngTemplateOutlet]="eregField"
				[ngTemplateOutletContext]="{
					field: {
						label: 'File #',
						value:
							vm.chargeObject?.Instrument?.ClientFileNumber?.ReferenceNumber,
						method: goToMatterOverview,
					},
				}"
			/>
			<div>Document Name</div>
			<app-input
				[ngModel]="
					(chargeDetails$ | async)?.[vm.mortgage?.id]?.documentName ??
					vm.chargeObject?.Instrument?.Name
				"
				(debounce)="updateDocumentName($event)"
			/>
		</div>
	</div>

	<div>
		<h5 class="h5 font-bold mb-4">Loan Details</h5>
		<div class="grid grid-cols-2 p-sm gap-x-6 gap-y-4">
			<ng-container
				[ngTemplateOutlet]="eregField"
				[ngTemplateOutletContext]="{
					field: {
						label: 'Principal Amount*',
						value: vm.chargeObject?.Instrument?.Amount,
					},
				}"
			/>
		</div>
	</div>

	<div>
		<h5 class="h5 font-bold mb-4">Terms & Payments</h5>
		<div class="grid grid-cols-2 p-sm gap-x-6 gap-y-4">
			<ng-container
				[ngTemplateOutlet]="eregField"
				[ngTemplateOutletContext]="{
					field: {
						label: 'Currency',
						value: 'CAD',
					},
				}"
			/>
			<ng-container
				[ngTemplateOutlet]="eregField"
				[ngTemplateOutletContext]="{
					field: {
						label: 'Interest Adjustment Date',
						value: vm.chargeObject?.Instrument?.InterestAdjustmentDate,
					},
				}"
			/>
			<ng-container
				[ngTemplateOutlet]="eregField"
				[ngTemplateOutletContext]="{
					field: {
						label: 'First Payment Date',
						value: vm.chargeObject?.Instrument?.FirstPaymentDate,
					},
				}"
			/>
			<ng-container
				[ngTemplateOutlet]="eregField"
				[ngTemplateOutletContext]="{
					field: {
						label: 'Last Payment Date',
						value: vm.chargeObject?.Instrument?.LastPaymentDate,
					},
				}"
			/>
			<ng-container
				[ngTemplateOutlet]="eregField"
				[ngTemplateOutletContext]="{
					field: {
						label: 'Balance Due Date',
						value: vm.chargeObject?.Instrument?.BalanceDueDate,
					},
				}"
			/>
			<ng-container
				[ngTemplateOutlet]="eregField"
				[ngTemplateOutletContext]="{
					field: {
						label: 'Interest Rate',
						value: vm.chargeObject?.Instrument?.InterestRate,
					},
				}"
			/>
			<ng-container
				[ngTemplateOutlet]="eregField"
				[ngTemplateOutletContext]="{
					field: {
						label: 'Calculation Period',
						value: vm.chargeObject?.Instrument?.CalculationPeriod,
					},
				}"
			/>
			<ng-container
				[ngTemplateOutlet]="eregField"
				[ngTemplateOutletContext]="{
					field: {
						label: 'Payment Date & Period',
						value: vm.chargeObject?.Instrument?.PaymentDate,
					},
				}"
			/>
			<ng-container
				[ngTemplateOutlet]="eregField"
				[ngTemplateOutletContext]="{
					field: {
						label: 'Insurance Amount',
						value: vm.chargeObject?.Instrument?.Insurance,
					},
				}"
			/>
			<ng-container
				[ngTemplateOutlet]="eregField"
				[ngTemplateOutletContext]="{
					field: {
						label: 'Standard Charge Term #',
						value: vm.chargeObject?.Instrument?.StdChargeTermsFileNr,
					},
				}"
			/>
			<ng-container
				[ngTemplateOutlet]="eregField"
				[ngTemplateOutletContext]="{
					field: {
						label: 'Regular Payments',
						value: vm.chargeObject?.Instrument?.AmountOfPayment,
					},
				}"
			/>
			<ng-container
				[ngTemplateOutlet]="eregField"
				[ngTemplateOutletContext]="{
					field: {
						label: 'Guarantor(s)',
						value: vm.chargeObject?.Instrument?.GuarantorName,
					},
				}"
			></ng-container>
			<ng-container
				[ngTemplateOutlet]="eregField"
				[ngTemplateOutletContext]="{
					field: {
						label: 'Additional Provisions',
						value: vm.chargeObject?.Instrument?.AdditionalTerms,
					},
				}"
			/>
		</div>
	</div>

	<div>
		<h5 class="h5 font-bold mb-4">Parties From</h5>
		<div class="grid grid-cols-2 p-sm gap-x-6 gap-y-4">
			<ng-container
				[ngTemplateOutlet]="eregField"
				[ngTemplateOutletContext]="{
					field: {
						label: 'Purchaser\'s Service Address',
						value: vm.chargeObject?.Instrument?.PartiesFrom?.AddressForService,
						method: goToPurchaserOrBorrower,
					},
				}"
			></ng-container>
		</div>
	</div>
	<div>
		<h5 class="h5 font-bold mb-4">Parties To</h5>
		<div class="flex flex-col p-sm gap-x-6 gap-y-4">
			<ng-container
				*ngFor="let partiesTo of vm.chargeObject?.Instrument?.PartiesTo"
			>
				<div class="grid grid-cols-2 gap-x-6 gap-y-4">
					<ng-container
						[ngTemplateOutlet]="eregField"
						[ngTemplateOutletContext]="{
							field: {
								label: 'Mortgagee',
								value: partiesTo?.FullName,
							},
						}"
					/>
					<ng-container
						[ngTemplateOutlet]="eregField"
						[ngTemplateOutletContext]="{
							field: {
								label: 'Mortgagee\'s Service Address',
								value: partiesTo?.AddressForService,
							},
						}"
					/>
				</div>
			</ng-container>
		</div>
	</div>

	<div>
		<h5 class="h5 font-bold mb-4">Property</h5>
		<div class="grid grid-cols-2 p-sm gap-x-6 gap-y-4">
			<ng-container
				[ngTemplateOutlet]="eregField"
				[ngTemplateOutletContext]="{
					field: {
						label: 'Interest/Estate',
						value: vm.interestEstate,
						method: goToMatterPropertyDetails,
					},
				}"
			/>

			<ng-container
				*ngFor="
					let title of (vm.matterTitles?.length ? vm.matterTitles : [{}])
						| sort: ['primary'] : ['desc']
				"
				class="mt-2"
				[ngTemplateOutlet]="eregField"
				[ngTemplateOutletContext]="{
					field: {
						label:
							title?.primary || !vm.matterTitles?.length
								? vm.pinsText + '*'
								: '',
						value: title?.pinNumber,
						method: goToMatterPropertyDetails,
					},
				}"
			/>
		</div>
	</div>

	<ng-template #eregField let-field="field">
		<div>{{ field.label }}</div>
		<div
			data-intercom-target="{{ field.intercomAttr || '' }}"
			class="hover:bg-grey-veryLight duration-100 cursor-pointer rounded-sm p-1"
			(click)="!!field.method ? field.method() : goToMortgage()"
		>
			{{ field.value || '-' }}
		</div>
	</ng-template>
</div>
